import { UserType } from "../enums";

export const hasPermission = (
  userType: UserType,
  accessedUserTypes: Array<UserType>,
): boolean => {
  if (!accessedUserTypes.length) return true;
  return accessedUserTypes.includes(userType);
};
